import { useMemo } from 'react';
import { useUnreadBulletinsCount } from './useUnreadBulletinsCount';
import { useUnreadPropertyChatCount } from '../residents/useUnreadPropertyChatCount';
import { useGetPendingFeedbackRequestsQuery, useGetMarketplaceNotificationsQuery } from '@/store/api';
import { useGetCorkBoardNotificationsQuery } from '@/store/api/corkBoard/corkBoardApi';
import { NOTIFICATION_TYPES } from '@/constants/residents/notifications';

/**
 * Hook that returns the total unread notifications count across the app.
 * Combines bulletins, marketplace feedback, marketplace notifications,
 * property chat, and cork board warnings.
 */
export const useUnreadNotificationsCount = () => {
  const bulletinsCount = useUnreadBulletinsCount();
  const propertyChatCount = useUnreadPropertyChatCount();
  
  const { data: pendingFeedbackRequests = [] } = useGetPendingFeedbackRequestsQuery(undefined, {
    pollingInterval: 60_000,
  });

  const { data: marketplaceNotifications = [] } = useGetMarketplaceNotificationsQuery(undefined, {
    pollingInterval: 60_000,
  });

  const { data: corkBoardNotifications = [] } = useGetCorkBoardNotificationsQuery(undefined, {
    pollingInterval: 60_000,
  });

  const unreadMarketplaceNotificationsCount = useMemo(() => {
    return marketplaceNotifications.filter(
      n => n.type === NOTIFICATION_TYPES.marketplaceReceivedFeedback.key && !n.isRead
    ).length;
  }, [marketplaceNotifications]);

  const unreadCorkBoardCount = useMemo(() => {
    return corkBoardNotifications.filter(n => !n.isRead).length;
  }, [corkBoardNotifications]);
  
  const totalCount = bulletinsCount + pendingFeedbackRequests.length + unreadMarketplaceNotificationsCount + propertyChatCount + unreadCorkBoardCount;
  
  return {
    total: totalCount,
    bulletins: bulletinsCount,
    pendingFeedback: pendingFeedbackRequests.length,
    unreadMarketplaceNotifications: unreadMarketplaceNotificationsCount,
    propertyChat: propertyChatCount,
    corkBoardWarnings: unreadCorkBoardCount,
  };
};
